import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  summary: null,
  day: null,
  filters: {
    from: "",
    to: "",
    status: "all",
    search: "",
  },
  list: [],
  total: 0,
  page: 1,
  pageSize: 50,
  booking: null,
  settings: null,
  specialDates: null,
  users: [],
};

const setSummary = (state, action) => (
  updateObject(state, {
    summary: action.summary,
  })
);

const setDay = (state, action) => (
  updateObject(state, {
    day: action.day,
  })
);

const setFilters = (state, action) => (
  updateObject(state, {
    filters: updateObject(state.filters, action.filters),
  })
);

const setList = (state, action) => (
  updateObject(state, {
    list: action.result.reservations,
    total: action.result.total,
    page: action.result.page,
    pageSize: action.result.pageSize,
  })
);

const setBooking = (state, action) => (
  updateObject(state, {
    booking: action.booking,
  })
);

//A quick status change on the day sheet - update that row without reloading the day
const updateInDay = (state, action) => {
  if (!state.day) {
    return state;
  }
  return updateObject(state, {
    day: updateObject(state.day, {
      reservations: state.day.reservations.map((r) => (r.id === action.booking.id ? { ...r, status: action.booking.status } : r)),
    }),
  });
};

const setSettings = (state, action) => (
  updateObject(state, {
    settings: action.settings,
  })
);

const setSpecialDates = (state, action) => (
  updateObject(state, {
    specialDates: action.specialDates,
  })
);

const setUsers = (state, action) => (
  updateObject(state, {
    users: action.users,
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_SUMMARY]: setSummary,
  [actionType.SET_DAY]: setDay,
  [actionType.SET_FILTERS]: setFilters,
  [actionType.SET_LIST]: setList,
  [actionType.SET_BOOKING]: setBooking,
  [actionType.UPDATE_IN_DAY]: updateInDay,
  [actionType.SET_SETTINGS]: setSettings,
  [actionType.SET_SPECIAL_DATES]: setSpecialDates,
  [actionType.SET_USERS]: setUsers,
});

export default reducer;

// SELECTORS
export const getSummary = (state) => state.summary;
export const getDay = (state) => state.day;
export const getFilters = (state) => state.filters;
export const getList = (state) => state.list;
export const getPaging = (state) => ({ total: state.total, page: state.page, pageSize: state.pageSize });
export const getBooking = (state) => state.booking;
export const getSettings = (state) => state.settings;
export const getSpecialDates = (state) => state.specialDates;
export const getUsers = (state) => state.users;
